module.exports = __webpack_public_path__ + "img/blog.f7690a9e.jpg";